module.exports = __webpack_public_path__ + "static/media/FeijaoPreto.3cbc48b7.png";